import { Component, forwardRef } from '@angular/core';
import { ANALYTICS_BASE_TOKEN, AnalyticsTablesBaseComponent } from '../analytics-tables-base/analytics-tables-base.component';
import { AnalyticsReportsColumns, AnalyticsReportsTypes } from '../analytics.conts';
import { ANALYTICS_SOURCE, ANALYTICS_TYPE, PRIIPsCostsTableData, PRIIPsReturnScenariosTableData, PRIIPsSummaryTableData } from '../analytics.interface';

@Component({
  selector: 'app-priips-tables',
  templateUrl: './priips-tables.component.html',
  styleUrls: [
    './priips-tables.component.scss',
    '../analytics-tables-base/analytics-tables-base.component.scss'
  ],
  providers: [{ provide: ANALYTICS_BASE_TOKEN, useExisting: forwardRef(() => PriipsTablesComponent) }],
})
export class PriipsTablesComponent extends AnalyticsTablesBaseComponent {

  // Columns:
  columns = AnalyticsReportsColumns.PRIIPS;

  // Data mapping:
  priipsSummaryData: PRIIPsSummaryTableData[];
  priipsReturnScenariosData: PRIIPsReturnScenariosTableData[];
  priipsCostsData: PRIIPsCostsTableData[];
  priipsSummaryDataAsOfDate: string;
  priipsSummaryDataAsOfDateFVC: string;
  priipsReturnScenariosDataAsOfDate: string;
  priipsCostsDataAsOfDate: string;

  prepareData(): void {
    this.priipsSummaryData = this.analyticsService.getPRIIPsSummaryTableData(
      this.data,
      this.tenor,
      this.source,
      this.productCaptureDetail
    );
    
    this.priipsReturnScenariosData =
      this.analyticsService.getPRIIPsReturnScenariosTableData(this.data, this.source);
    this.priipsCostsData = this.analyticsService.getPRIIPsCostsTableData(this.data, this.source);

    this.priipsSummaryDataAsOfDate = this.analyticsService.getCreationDate(
      this.data,
      ANALYTICS_SOURCE.CLOUD_RISK,
      ANALYTICS_TYPE.PRIIPS_SUMMARY
    );

    let source = ANALYTICS_SOURCE.CLOUD_RISK;
    if (!this.priipsSummaryDataAsOfDate) {
      this.priipsSummaryDataAsOfDate = this.analyticsService.getCreationDate(
        this.data,
        ANALYTICS_SOURCE.FVC,
        ANALYTICS_TYPE.PRIIPS_SUMMARY
      );
      source = ANALYTICS_SOURCE.FVC;
    }

    this.priipsReturnScenariosDataAsOfDate =
      this.analyticsService.getCreationDate(
        this.data,
        source,
        ANALYTICS_TYPE.PRIIPS_SCENARIOS
      );
    this.priipsCostsDataAsOfDate = this.analyticsService.getCreationDate(
      this.data,
      source,
      ANALYTICS_TYPE.PRIIPS_COSTS
    );
  }

  isDataAvailable(): boolean {
    return !!(this.priipsSummaryData ||
              this.priipsReturnScenariosData ||
              this.priipsCostsData)
  }

  get reportType(): AnalyticsReportsTypes {
    return AnalyticsReportsTypes.PRIIPS;
  }

}
